import { defaultAgreementStatus } from '@/_schemas/agreements/agreement-status-schema';
import { defaultPipeline } from '@/_schemas/agreements/agreements-pipeline-schemas';
import { defaultBooleanValue } from '@/_schemas/generic';
import { dateTime } from '@/_shared';

import type { AgreementFormSchema } from '../schemas';

const now = dateTime.now();
const end = now.add(90, 'days');

// export const defaultAccountManagerOption = {
//   id: -1,
//   first_name: '',
//   last_name: '',
//   profile_image: null,
// };

const defaultClientOption = {
  id: -1,
  name: '',
  contacts: null,
  domains: null,
  addresses: null,
  status: null,
  logo: null,
  partner: null,
  brand: null,
  account_number: null,

  tax_id: null,
  exempt: null,
};

export const defaultValues: Readonly<AgreementFormSchema> = {
  id: -1,
  pipeline: defaultPipeline,
  agreement_date: now.format('YYYY-MM-DD'),
  expiry_date: end.format('YYYY-MM-DD'),
  client: defaultClientOption,
  status: defaultAgreementStatus,
  account_manager: [],
  agreement_id: '',

  agreement_deliverables: [],
  tempAgreement_deliverables: [],
  primary_domains: null,

  purchase_order: '',
  agreement_contact: null,
  project_contact: null,
  billing_contact: null,
  emergency_contact: [],
  billing_email_contacts: [],
  billing_term: null,

  terms_condition_template: null,
  agreement_signer: null,
  brand: null,
  partner: null,
  harvest: '',

  agreement_installments: [],
  wholesale_price_enabled: false,
  selectedWholesaleDateRange: null,

  addresses: null,
  parent: null,
  parent_id: null,
  addendums: [],

  exclude_from_averages: false,

  subsidies: null,
  agreement_commissions: null,
  enable_commission: false,

  contracting_party: null,

  orphan_invoicing: defaultBooleanValue(),
} as const;
